// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_contact(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "SharingContactClientContactV5",
    "SharingContactFreshContactV5"
  ]);
}

let fragmentConverter = {"__root":{"lastClickedAt":{"b":""},"contact_SharingContactFreshContactV5_email":{"b":""},"contact_SharingContactClientContactV5_email":{"b":""},"contact":{"u":"fragment_contact"}}};

let fragmentConverterMap = {
  fragment_contact: unwrap_fragment_contact
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function sharedPropertyEmailStatsForRecipientEmailStatus_decode($$enum) {
  if ($$enum === "CLICKED" || $$enum === "DELIVERED") {
    return $$enum;
  }
}

let sharedPropertyEmailStatsForRecipientEmailStatus_fromString = sharedPropertyEmailStatsForRecipientEmailStatus_decode;

let Utils = {
  sharedPropertyEmailStatsForRecipientEmailStatus_decode: sharedPropertyEmailStatsForRecipientEmailStatus_decode,
  sharedPropertyEmailStatsForRecipientEmailStatus_fromString: sharedPropertyEmailStatsForRecipientEmailStatus_fromString
};

let node = ((function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedPostEmailStatsSingleRecipient_recipient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "SharingContactClientContactV5",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "SharingContactFreshContactV5",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastClickedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfClicks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "SharedPropertyEmailStatsForRecipient",
  "abstractKey": null
};
})());

let wrap_fragment_contact = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_contact = unwrap_fragment_contact;
exports.wrap_fragment_contact = wrap_fragment_contact;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
